import { createReducer, on, Action } from '@ngrx/store';
import { GameOver, PlayInstance } from '@fantaz/shared/data-access/models';

import * as GameOverActions from './game-over.actions';

export const GAME_OVER_FEATURE_KEY = 'gameOver';

export interface GameOverState {
  gameOver: GameOver | null; // has the GameOver list been loaded
  loaded: boolean; // has the GameOver list been loaded
  error?: string | null; // last known error (if any)
  selectedPlayInstance: PlayInstance | null; // last known error (if any)
}

export interface GameOverPartialState {
  readonly [GAME_OVER_FEATURE_KEY]: GameOverState;
}

export const gameOverInitialState: GameOverState = {
  // set initial required properties
  gameOver: null,
  loaded: false,
  error: null,
  selectedPlayInstance: null,
};

const reducer = createReducer(
  gameOverInitialState,
  on(GameOverActions.loadGameOver, (state, { silent }) => {
    const loaded = !!silent;
    return {
      ...state,
      loaded,
      error: null,
    };
  }),
  on(GameOverActions.loadGameOverSuccess, (state, { gameOver }) => {
    return {
      ...state,
      loaded: true,
      gameOver,
      selectedPlayInstance: gameOver.lastPlayInstance,
    };
  }),
  on(GameOverActions.loadGameOverFailure, (state, { error }) => ({
    ...state,
    error,
  })),
);

export function gameOverReducer(
  state: GameOverState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
